import sweepStore from '../store/store';
import { trace } from 'owa-trace';
import { action, select } from 'satcheljs/lib/legacy';
import { format } from 'owa-strings';
/**
 * Validate the old and new sweep request states are expected
 * @param oldStatus current sweep request status in store
 * @param newStatus the sweep request status to be set
 */
function validateSweepRequestState(oldStatus, newStatus) {
    var errorStr = 'Invalid state transition {0} to {1}';
    if (newStatus == 1 /* Pending */ && oldStatus != 0 /* NotInitiated */) {
        trace.error(format(errorStr, oldStatus, newStatus));
    }
    if ((newStatus == 2 /* Complete */ || newStatus == 3 /* Error */) &&
        oldStatus != 1 /* Pending */) {
        trace.error(format(errorStr, oldStatus, newStatus));
    }
}
/**
 * Set the SweepRequestStatus in sweep store
 * @param requestStatus the sweep request status to set
 * @param state the state which contains the sweep store
 */
export default action('setSweepRequestStatus')(select({
    sweepStore: function () { return sweepStore; },
})(function setSweepRequestStatus(requestStatus, state) {
    var sweepStore = state.sweepStore;
    if (!sweepStore.isSweepDialogShown) {
        // Do nothing if the sweep dialog is hidden when try setting SweepRequestStatus, e.g. user dismisses the
        // dialog when the request is outstanding.
        return;
    }
    validateSweepRequestState(sweepStore.sweepRequestStatus, requestStatus);
    sweepStore.sweepRequestStatus = requestStatus;
}));
//# sourceMappingURL=setSweepRequestStatus.js.map